import React, { type FC, type ReactNode, use } from "react";
import { Button, Card } from "@heroui/react";
import { FileQuestion, Server } from "@gravity-ui/icons";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";

import { AppError, AppSettingsContext } from "@domain/context/AppSettingsProvider";

type ErrorProps = { title: ReactNode; subTitle?: ReactNode };

const DB_ERROR_EMAIL_VALUES = { email: <a href="mailto:support@binale.de">support@binale.de</a> };

const reloadPage = () => location.reload();

export const ErrorView: FC = () => {
    const { appError } = use(AppSettingsContext);

    const commonError: ErrorProps = {
        title: <FormattedMessage id="app.error_page.title.problem_with_db" />,
        subTitle: (
            <div className="max-w-250">
                <div>
                    1. <FormattedMessage id="app.error_page.fix_problems_with_db.1" />
                </div>
                <div>
                    2. <FormattedMessage id="app.error_page.fix_problems_with_db.2" />
                </div>
                <div>
                    3. <FormattedMessage id="app.error_page.fix_problems_with_db.3" values={DB_ERROR_EMAIL_VALUES} />
                </div>
            </div>
        ),
    };

    const resultProps: Record<AppError, ErrorProps> = {
        [AppError.FirebaseConnectionError]: commonError,
        [AppError.IndexedDB]: commonError,
        [AppError.ReactRendering]: {
            title: <FormattedMessage id="app.error_page.title.something_went_wrong" />,
            subTitle: <FormattedMessage id="app.error_page.we_already_fix_it" />,
        },
    };
    return (
        <div className="flex items-center justify-center h-full">
            <Card className="max-w-lg w-full text-center p-8">
                <Card.Content className="flex flex-col items-center gap-6">
                    <Server className="text-danger size-16" strokeWidth={1.5} />
                    <div>
                        <h2 className="text-2xl font-semibold mb-2">{resultProps[appError].title}</h2>
                        <div className="text-muted">{resultProps[appError].subTitle}</div>
                    </div>
                    <Button onPress={reloadPage}>
                        <FormattedMessage id="app.error_page.button.reload_page" />
                    </Button>
                </Card.Content>
            </Card>
        </div>
    );
};

export const NotFoundView = () => (
    <div className="flex items-center justify-center h-full">
        <Card className="max-w-lg w-full text-center p-8">
            <Card.Content className="flex flex-col items-center gap-6">
                <FileQuestion className="text-muted size-16" strokeWidth={1.5} />
                <h2 className="text-2xl font-semibold">
                    <FormattedMessage id="app.error_page.not_found" />
                </h2>
                <Link to="/">
                    <Button>
                        <FormattedMessage id="app.error_page.button.back_home" />
                    </Button>
                </Link>
            </Card.Content>
        </Card>
    </div>
);
